import { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * 通用模态对话框（初学者工作台用，保持简单）：
 * - 遮罩点击 / Esc 关闭；内容区点击不穿透；
 * - 无焦点陷阱（范围外交互需求少），后续需要可增强。
 */

export interface ModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  /** 底部操作区（保存/取消按钮等），放在 dialog footer */
  footer?: React.ReactNode;
  /** 对话框宽度类名（默认 460px） */
  width?: 'sm' | 'md' | 'lg';
}

export default function Modal({ open, title, onClose, children, footer, width = 'md' }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal modal--${width}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-head">
          <span className="modal-title">{title}</span>
          <button type="button" className="btn btn-icon" onClick={onClose} aria-label="关闭对话框">
            <X size={16} />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
